import { ReactComponent as AnimatedPaywallBg } from "./svg//animatedPaywallBg.svg"
import { ReactComponent as Bolt } from "./svg//bolt.svg"
import { ReactComponent as CheckmarkCircle } from "./svg//checkmarkCircle.svg"
import { ReactComponent as Graph } from "./svg//graph.svg"
import { ReactComponent as Info } from "./svg//info.svg"
import { ReactComponent as PremiumBadge } from "./svg//premiumBadge.svg"
import { ReactComponent as PremiumIcon } from "./svg//premiumIcon.svg"
import { ReactComponent as PremiumOrangeHeader } from "./svg//premiumOrangeHeader.svg"
import { ReactComponent as PricingDecoration } from "./svg//pricingDecoration.svg"
import { ReactComponent as StarReview } from "./svg//starReview.svg"
import { ReactComponent as StartsLeft } from "./svg//startsLeft.svg"
import { ReactComponent as StartsRight } from "./svg//startsRight.svg"
import { ReactComponent as UltimateBadge } from "./svg//ultimateBadge.svg"
import { ReactComponent as UltimateIcon } from "./svg//ultimateIcon.svg"
import { ReactComponent as BannerIcon } from "./svg/autumn//bannerIcon.svg"
import { ReactComponent as Bottom } from "./svg/autumn//bottom.svg"
import { ReactComponent as Top } from "./svg/autumn//top.svg"
import { ReactComponent as Adfree } from "./svg/featureIcons//adfree.svg"
import { ReactComponent as Breakin } from "./svg/featureIcons//breakin.svg"
import { ReactComponent as CloudVault } from "./svg/featureIcons//cloudVault.svg"
import { ReactComponent as Decoy } from "./svg/featureIcons//decoy.svg"
import { ReactComponent as Disguise } from "./svg/featureIcons//disguise.svg"
import { ReactComponent as DuplicateDetection } from "./svg/featureIcons//duplicateDetection.svg"
import { ReactComponent as FacedownLock } from "./svg/featureIcons//facedownLock.svg"
import { ReactComponent as OrganizationPlus } from "./svg/featureIcons//organizationPlus.svg"
import { ReactComponent as PatternLock } from "./svg/featureIcons//patternLock.svg"
import { ReactComponent as SecurityPlus } from "./svg/featureIcons//securityPlus.svg"
import { ReactComponent as SpaceSaver } from "./svg/featureIcons//spaceSaver.svg"
import { ReactComponent as Star } from "./svg/featureIcons//star.svg"
import { ReactComponent as Trash } from "./svg/featureIcons//trash.svg"
import { ReactComponent as Wifi } from "./svg/featureIcons//wifi.svg"
import { ReactComponent as SpringBanner } from "./svg/spring//springBanner.svg"
import { ReactComponent as SpringHeader } from "./svg/spring//springHeader.svg"
import { ReactComponent as SpringHeaderDecoration } from "./svg/spring//springHeaderDecoration.svg"
import { ReactComponent as WinterBanner } from "./svg/winter//winterBanner.svg"

const autumn = {
  BannerIcon,
  Bottom,
  Top,
}

const featureIcons = {
  Adfree,
  Breakin,
  CloudVault,
  Decoy,
  Disguise,
  DuplicateDetection,
  FacedownLock,
  OrganizationPlus,
  PatternLock,
  SecurityPlus,
  SpaceSaver,
  Star,
  Trash,
  Wifi,
}

const spring = {
  SpringBanner,
  SpringHeader,
  SpringHeaderDecoration,
}

const winter = {
  WinterBanner,
}

export default {
  AnimatedPaywallBg,
  Bolt,
  CheckmarkCircle,
  Graph,
  Info,
  PremiumBadge,
  PremiumIcon,
  PremiumOrangeHeader,
  PricingDecoration,
  StarReview,
  StartsLeft,
  StartsRight,
  UltimateBadge,
  UltimateIcon,
  autumn,
  featureIcons,
  spring,
  winter,
}
